module.exports = __webpack_public_path__ + "media/images/ellipsis-d00ac776da052bd85c0e01cb9daab4b5.png";